import { Injectable, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  private breakpointObserver = inject(BreakpointObserver);

  // Define breakpoints matching Tailwind config
  private readonly mobileQuery = '(max-width: 767px)';
  private readonly tabletQuery = '(min-width: 768px) and (max-width: 1279px)';
  private readonly desktopQuery = '(min-width: 1280px)';
  private readonly handsetLandscapeQuery = '(max-width: 959px) and (orientation: landscape)';

  // Observables
  readonly isMobile$ = this.breakpointObserver.observe(this.mobileQuery).pipe(
    map((result) => result.matches),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  readonly isTablet$ = this.breakpointObserver.observe(this.tabletQuery).pipe(
    map((result) => result.matches),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  readonly isDesktop$ = this.breakpointObserver.observe(this.desktopQuery).pipe(
    map((result) => result.matches),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  readonly isHandsetLandscape$ = this.breakpointObserver.observe(this.handsetLandscapeQuery).pipe(
    map((result) => result.matches),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  // Signals for easy modern template/component consumption
  readonly isMobile = toSignal(this.isMobile$, { initialValue: false });
  readonly isTablet = toSignal(this.isTablet$, { initialValue: false });
  readonly isDesktop = toSignal(this.isDesktop$, { initialValue: true });
  readonly isHandsetLandscape = toSignal(this.isHandsetLandscape$, { initialValue: false });
}
